'use client';

import * as React from 'react';

export interface InfoDotProps {
	/** Pannello aperto: guida `aria-expanded` e il tooltip. */
	open: boolean;
	/** Apre e chiude il pannello. */
	onToggle: () => void;
	/** Cosa spiega il pannello: finisce in `aria-label` e `title`. */
	label: string;
}

/**
 * La «i» che il mock v11 mette accanto al titolo di pagina per aprire la
 * spiegazione del metodo (`Anomalie`, `Incentivi`).
 *
 * È un cerchietto e non un bottone con etichetta perché la spiegazione non è
 * un'azione della pagina: chi legge i numeri per la decima volta non deve
 * scavalcare un comando che non userà. Il testo accessibile lo porta comunque,
 * via `aria-label`.
 */
export function InfoDot({ open, onToggle, label }: InfoDotProps) {
	return (
		<button
			type="button"
			onClick={onToggle}
			aria-expanded={open}
			aria-label={label}
			title={label}
			className="flex h-[22px] w-[22px] items-center justify-center rounded-full border-[1.5px] border-accent font-serif text-[13px] font-extrabold italic text-accent transition-colors hover:bg-accent/10"
		>
			i
		</button>
	);
}
InfoDot.displayName = 'InfoDot';
